import React from 'react';

// The one sortable table header for Docket's server-paginated lists
// (contracts, TPRM requests, document reviews, counterparties). Lifted here
// when the third list needed it — the markup was already duplicated verbatim
// in ContractsListTable and RequestsList, so a fourth copy was the
// alternative. Small unicode caret shown only on the active column.
export default function SortableHeader({ field, children, sortField, sortOrder, onToggle, style, align }) {
  const active = sortField === field;
  return (
    <th
      className="sortable"
      aria-sort={active ? (sortOrder === 'asc' ? 'ascending' : 'descending') : undefined}
      style={{ textAlign: align || 'left', ...style }}
    >
      {/* The control is a real <button>, not a click handler on the <th>: that
          puts it in the tab order and gets Enter/Space activation (and Space
          not scrolling the page) from the platform instead of a hand-rolled
          onKeyDown. aria-sort stays on the <th> — it describes the column, not
          the button. The button takes over the cell's padding in CSS so the
          whole header cell is still the mouse target. */}
      <button type="button" onClick={() => onToggle(field)}>
        <span className="row" style={{ gap: 4, display: 'inline-flex' }}>
          {children}
          {/* aria-hidden: a <th>'s accessible name is computed from its
              contents, so an exposed caret would be recited on every cell of
              the active column during table navigation (doc-247). The
              direction is already announced from aria-sort above — the
              supported, localised channel — so the glyph is pure duplication
              to assistive tech and decoration to everyone else. */}
          {active && (
            <span aria-hidden="true" style={{ fontSize: 9, opacity: 0.6 }}>
              {sortOrder === 'asc' ? '▲' : '▼'}
            </span>
          )}
        </span>
      </button>
    </th>
  );
}
